import { Space, Tabs } from "antd";
import React from "react";
import styles from "./index.module.less";

const SearchHeader = ({type,onTypeChange}) => {
  const tabList = ["firmware", "documents", "DeveloperTools"].map(v => {
    return {
      key: v,
      tab: v,
    };
  });

  return (
    <Space
      direction="vertical"
      style={{ width: "100%" }}
      size={0}
    >
      <div className={styles.tabContainer}>
        <Tabs
          type="card"
          defaultValue="firmware"
          activeKey={type}
          onChange={(v) => {
            onTypeChange(v)
          }}
        >
          {tabList.map((v, index) => (
            <Tabs.TabPane
              {...v}
              tab={v.tab.charAt(0).toUpperCase() + v.tab.slice(1)}
              key={v.key || index}
            />
          ))}
        </Tabs>
      </div>
    </Space>
  );
};

export default SearchHeader;
